import { render, staticRenderFns } from "./ValueWidget.vue?vue&type=template&id=117cc176&scoped=true&"
import script from "./ValueWidget.vue?vue&type=script&lang=js&"
export * from "./ValueWidget.vue?vue&type=script&lang=js&"
import style0 from "./ValueWidget.vue?vue&type=style&index=0&id=117cc176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cc176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
